/**
 * 기본 서비스 사용처
 */
const DefaultEntry = {
    ETC: 'ETC',
} as const

/**
 * 서비스 사용처를 구분
 * - 디컨 진입 서비스
 * @link https://wiki.fin.navercorp.com/spaces/FIN/pages/120900972/%EB%94%94%EC%A7%80%ED%84%B8%EC%BD%98%ED%85%90%EC%B8%A0+svcseq+%EC%A0%95%EB%A6%AC
 */
export const DiconEntry = {
    /** 스노우 B612 */
    B612: 'B612',
    /** 네이버 치지직 프라임 */
    CHZZK_PRIME: 'CHZZK_PRIME',
    /** 네이버 치지직 */
    CHZZK: 'CHZZK',
    /** 클로바 더빙 */
    CLOVA_DUBBING: 'CLOVA_DUBBING',
    /** 클로바 노트 */
    CLOVA_NOTE: 'CLOVA_NOTE',
    /** 네이버페이 대출 > 신용관리 서비스 */
    CREDIT_MANAGEMENT: 'CREDIT_MANAGEMENT',
    /** 네이버페이 상품권 */
    GIFT_CARD: 'GIFT_CARD',
    /** 해피빈 */
    HAPPY_BEAN: 'HAPPY_BEAN',
    /** 지식iN eXpert */
    KIN: 'KIN',
    /** MY골프 */
    MY_GOLF: 'MY_GOLF',
    /** 네이버 MY박스 */
    MYBOX: 'MYBOX',
    /** 네이버 비지니스 스쿨 */
    NAVER_BUSINESS_SCHOOL: 'NAVER_BUSINESS_SCHOOL',
    /** Ncloud(네이버클라우드플랫폼) */
    N_CLOUD: 'N_CLOUD',
    /** N스토어 */
    N_STORE: 'N_STORE',
    /** 네이버게임 - 게임캐쉬 */
    NAVER_GAME: 'NAVER_GAME',
    /** 네이버플러스멤버십 */
    NAVER_MEMBERSHIP: 'NAVER_MEMBERSHIP',
    /** 네이버 OGQ 마켓 */
    OGQ_MARKET: 'OGQ_MARKET',
    /** 파파고 */
    PAPAGO: 'PAPAGO',
    /** 프리미엄콘텐츠 */
    PREMIUM_CONTENTS: 'PREMIUM_CONTENTS',
    /** 네이버 검색 광고 */
    SEARCH_AD: 'SEARCH_AD',
    /** 시리즈E북 */
    SERIES_EBOOK: 'SERIES_EBOOK',
    /** 시리즈 */
    SERIES: 'SERIES',
    /** SNOW */
    SNOW: 'SNOW',
    /** 타로툰 */
    TAROTOON: 'TAROTOON',
    /** 바이브 */
    VIBE: 'VIBE',
    /** 웹툰 AILABS */
    WEBTOON_AILABS: 'WEBTOON_AILABS',
    /** 스노우 법인 비지니스 편집툴 */
    WIKIT: 'WIKIT',
} as const

export const PaymentMethodManagementEntry = {
    /** 예약/주문 자동결제 */
    BOOKING: 'BOOKING',
    /** 정기구독 */
    SUBSCRIPTION: 'SUBSCRIPTION',
    /** 패밀리결제 */
    FAMILY_PAY: 'FAMILY_PAY',
} as const

export const OrderSheetEntry = {
    /** 1. 가맹점 - 네이버페이 가맹점 */
    CHECKOUT: 'CHECKOUT',
    /** 2. 예약/블로그/카페 - 네이버 예약 */
    EASY_BOOKING: 'EASY_BOOKING',
    /** 2. 예약/블로그/카페 - 테이블오더(v1, v2) */
    LOCAL_PAY: 'LOCAL_PAY',
    /** 2. 예약/블로그/카페 - 네이버 까페(v1) */
    NAVER_CAFE: 'NAVER_CAFE',
    /** 주문완료에서는 네이버카페가 아래와 같이 내려온다 수정 요청 필요 */
    NAVERCAFE: 'NAVERCAFE',
    /** 플리마켓(카페) 구매자보호 수수료 */
    FLEA_MARKET: 'FLEA_MARKET',
    /** 2. 예약/블로그/카페 - 네이버 블로그(v2) */
    NAVER_BLOG: 'NAVER_BLOG',
    /** 주문완료에서는 블로그가 아래와 같이 내려옴 */
    NAVERBLOG: 'NAVERBLOG',
    /** 3. 스마트스토어 */
    SHOPN: 'SHOPN',
    /** 3. 스마트스토어 - 선물하기 */
    GIFTING: 'GIFTING',
    /** 3. 스마트스토어 - 장보기 */
    BRANCH: 'BRANCH',
    /** 4. 패밀리 결제 */
    FAMILY_PAY: 'FAMILY_PAY',
} as const

export const ScheduledOrderEntry = {
    /** 정기구독 */
    SUBSCRIPTION: 'SUBSCRIPTION',
    /** 주문형 해피빈 */
    HAPPY_BEAN_ORDER: 'HAPPY_BEAN',
    /** 그룹구매 */
    GROUP_PURCHASE: 'GROUP_PURCHASE',
    /** 렌탈 */
    RENTAL: 'RENTAL',
    /** 매장방문결제 */
    POST_PAYMENT: 'POST_PAYMENT',
} as const

export const OrderEntry = {
    ...OrderSheetEntry,
    ...PaymentMethodManagementEntry,
    ...ScheduledOrderEntry,
    ...DefaultEntry,
} as const

export const PartnersEntry = {
    WETAX: 'WETAX',
} as const

export const PaymentDetailEntry = {
    /** 결제형 단건 */
    PAYMENT_DETAIL_NORMAL: 'PAYMENT_DETAIL_NORMAL',
    /** 결제형 자동 */
    PAYMENT_DETAIL_RECURRENT: 'PAYMENT_DETAIL_RECURRENT',
    /** 인증형 단건 */
    PAYMENT_DETAIL_AUTH: 'PAYMENT_DETAIL_AUTH',
    /** 인증형 자동 */
    PAYMENT_DETAIL_AUTH_AUTOMATIC: 'PAYMENT_DETAIL_AUTH_AUTOMATIC',
    /** 현장결제 */
    PAYMENT_DETAIL_OFFLINE: 'PAYMENT_DETAIL_OFFLINE',
    /** 자체가맹점 */
    PAYMENT_DETAIL_INSTORE: 'PAYMENT_DETAIL_INSTORE',
} as const

export type PaymentDetailEntryType = Constant<typeof PaymentDetailEntry>

export const InvoiceEntry = {
    INVOICE: 'INVOICE',
} as const

export type InvoiceEntryType = Constant<typeof InvoiceEntry>

export const Entry = {
    ...DiconEntry,
    ...OrderEntry,
    ...ScheduledOrderEntry,
    ...PartnersEntry,
    ...PaymentDetailEntry,
    ...InvoiceEntry,
    ...DefaultEntry,
}

export type EntryType = Constant<typeof Entry>
